import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.origin.includes('localhost') ? 'http://localhost:8080/api' : `${window.location.origin}/api`);

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Error al enviar solicitud');
      }

      setSent(true);
    } catch (err) {
      setError(err.message || 'Error al enviar solicitud. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-df-surface2 py-12 px-4">
        <div className="max-w-md w-full bg-df-surface border border-df-border p-8 rounded-lg shadow-md text-center">
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-df-success/10 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-df-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
          <h2 className="text-2xl font-bold text-df-text mb-4">Revisa tu correo</h2>
          <p className="text-df-muted mb-6">
            Si el email <strong>{email}</strong> está registrado, recibirás un enlace para restablecer tu contraseña.
          </p>
          <p className="text-sm text-df-muted mb-6">
            El enlace expira en 1 hora. Si no lo ves, revisa tu carpeta de spam.
          </p>
          <Link
            to="/login"
            className="inline-block bg-df-accent-strong text-white px-6 py-2 rounded-md hover:bg-df-accent-deep transition-colors"
          >
            Volver al inicio de sesión
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-df-surface2 py-12 px-4">
      <div className="max-w-md w-full bg-df-surface border border-df-border p-8 rounded-lg shadow-md">
        <div className="text-center mb-6">
          <div className="mx-auto w-16 h-16 bg-df-accent/10 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-df-accent-hover" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-df-text">¿Olvidaste tu contraseña?</h2>
          <p className="text-df-muted mt-2">
            Ingresa tu email y te enviaremos un enlace para restablecerla.
          </p>
        </div>

        {error && (
          <div className="bg-df-danger/10 border-l-4 border-df-danger p-4 mb-4">
            <p className="text-sm text-df-danger">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-df-text mb-1">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-3 py-2 border border-df-border rounded-md focus:outline-none focus:ring-2 focus:ring-df-accent focus:border-transparent"
              placeholder="tu@email.com"
            />
          </div>

          <button
            type="submit"
            disabled={loading || !email}
            className="w-full bg-df-accent-strong text-white py-2 px-4 rounded-md hover:bg-df-accent-deep transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium"
          >
            {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link
            to="/login"
            className="text-sm text-df-accent-hover hover:text-df-accent font-medium"
          >
            ← Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
